import { render, staticRenderFns } from "./FormProductSubcategoryComponent.vue?vue&type=template&id=6eb58f96&scoped=true"
import script from "./FormProductSubcategoryComponent.vue?vue&type=script&lang=js"
export * from "./FormProductSubcategoryComponent.vue?vue&type=script&lang=js"
import style0 from "./FormProductSubcategoryComponent.vue?vue&type=style&index=0&id=6eb58f96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb58f96",
  null
  
)

export default component.exports